import * as React from 'react';

import type { SocialTrackingMetadataInput } from '@xing-com/crate-common-graphql-types';

export type TrackingPropsContextType = {
  backendTrackingMetaData: SocialTrackingMetadataInput;
  entryPoint: string;
  inputHintClick: boolean;
  interactionTargetUrn: string;
  propChannel: string;
  propSocialInteractionId: string;
  propSourceType: string;
  trackingToken?: string | null;
};

export const TrackingPropsContext =
  React.createContext<TrackingPropsContextType>({
    backendTrackingMetaData: { trackingTokens: [], page: '', position: '' },
    trackingToken: '',
    entryPoint: '',
    inputHintClick: false,
    interactionTargetUrn: '',
    propChannel: '',
    propSocialInteractionId: '',
    propSourceType: '',
  });
